import { NgModule } from '@angular/core';
import { LoginBgComponent } from './login-bg.component';

@NgModule({
    declarations: [LoginBgComponent],
    exports: [LoginBgComponent]
})
export class LoginBgModule { }
